import { useEffect, useRef, useState, Suspense } from "react";
import {useRouter} from "next/router";
import VariantBHeroSection from "@/components/tour/sections/variantB/VariantBHeroSection";
import VariantBLogosSection from "@/components/tour/sections/variantB/VariantBLogosSection";
import VariantBWillDoSection from "@/components/tour/sections/variantB/VariantBWillDoSection";
import VariantBBookingSection from "@/components/tour/sections/variantB/VariantBBookingSection";
import VariantBVideoSection from "@/components/tour/sections/variantB/VariantBVideoSection";
import VariantBImagesSection from "@/components/tour/sections/variantB/VariantBImagesSection";
import VariantBWillTasteSection from "@/components/tour/sections/variantB/VariantBWillTasteSection";
import VariantBMeetingSpotsSection from "@/components/tour/sections/variantB/VariantBMeetingSpotsSection";
import FactsSection from "@/components/tour/sections/variantB/FactsSection";
import VariantBAboutSection from "@/components/tour/sections/variantB/VariantBAboutSection";
import VariantBSimilarToursSection from "@/components/tour/sections/variantB/VariantBSimilarToursSection";
import VariantBFaqSection from "@/components/tour/sections/variantB/VariantBFaqSection";
import VariantBBookEndSection from "@/components/tour/sections/variantB/VariantBBookEndSection";
import TourHeroSection from "@/components/tour/sections/TourHeroSection";
import EmbeddedPageSection from "@/components/other/EmbeddedPageSection";
import styled from "styled-components";
import {breakpoints} from "@/styles/sizes";
import VariantBHeroSectionMobile from "@/components/tour/sections/variantB/VariantBHeroSectionMobile";
import useIsMobile from "@/hooks/useIsMobile";


export default function TourPageVariantB({ data, isMobileDefault = false }) {
    const isMobile = useIsMobile(isMobileDefault);

    const {
        reviewOverlay,
        bookingLogo,
        page,
        footer,
        socialLinks
    } = data?.data || {};

    const {
        title,
        city,
        heroImage,
        isUpgrade,
        data: pageData,
        faqs,
        images,
        videoThumbnail,
        similarTours,
        bookingAwardsImage,
        bookingLowestPriceFlag,
        pressLogos
    } = page || {};

    const pressLogosForDisplay = pressLogos?.length
        ? pressLogos.map((logo) => ({ src: logo.url, alt: logo.alt || logo.name }))
        : undefined;

    const {
        info,
        media,
        whatYouWillDo,
        meetings,
        whatYouWillTaste,
        why,
        similar,
        embedded,
        facts,
    } = pageData || {};

    const sidebarScrollToDivRef = useRef(null);
    const scrollToDivRef = useRef(null);
    const titleRef = useRef();


    const router = useRouter();

    useEffect(() => {
        if (router.isReady && router.asPath.includes("#FAQ") || router.asPath.includes("#BOOKING")|| router.asPath.includes("#CONTACT")) {
            setTimeout(() => {
                if(router.asPath.includes("#FAQ")){
                    const section = document.getElementById("FAQ");
                    if (section) {
                        section.scrollIntoView({ behavior: "smooth" });
                    }
                }else if(router.asPath.includes("#BOOKING")){
                    const section = document.getElementById("BOOKING");
                    if (section) {
                        section.scrollIntoView({ behavior: "smooth" });
                    }
                }else if(router.asPath.includes("#CONTACT")){
                    const section = document.getElementById("CONTACT");
                    if (section) {
                        section.scrollIntoView({ behavior: "smooth" });
                    }
                }
            },500)
        }
    }, [router]);

    const bookingButtonData = (pageData?.showDropdown ? pageData?.dropdowns : [])?.find(item => item?.item_type === 'booking_button');

    return (
        <>

            {!isMobile && <VariantBHeroSection
                titleRef={titleRef}
                reviewOverlayData={reviewOverlay}
                heroReviewsText={info?.heroReviewsText}
                title={title}
                cityName={city?.name}
                heroMedia={heroImage}
                backgroundImageUrl={heroImage?.url}
                scrollToDivRef={sidebarScrollToDivRef}
                socialLinks={socialLinks}
                heroTitle={info?.heroTitle}
                heroDescription={info?.heroDescription}
                rating={info?.rating}
                subtitle={pageData?.hero?.subtitle}
                isUpgrade={isUpgrade}
                breadcrumbs={
                    isUpgrade
                        ? [
                            { title: "Home", link: "/" },
                            { title: city?.name, link: city?.slug },
                            { title: page?.upgradeForTour?.title, link: page?.upgradeForTour?.slug },
                            { title },
                        ]
                        : [
                            { title: "Home", link: "/" },
                            { title: city?.name, link: city?.slug },
                            { title },
                        ]
                }
                dropdownData={pageData?.showDropdown ? pageData?.dropdowns : []}
                dropdownBackButtonText={page?.city?.name}
                dropdownBackButtonLink={page?.city?.slug}
                isEmbeddedPage={!!embedded?.embed}


                duration={info?.duration}
                location={info?.location}
                numOfStops={info?.numOfStops ? `${info?.numOfStops} ${info?.stopsText ?? 'stops'}` : null}
                numOfPeople={info?.numOfPeople ? `${info?.numOfPeople} ${info?.peopleText ?? 'people max'}` : null}
                type={info?.type}
                funFact={info?.funFact}
                language={info?.language}
                wineTastings={info?.wineTastings}

                ctaButtonData={bookingButtonData}
                pressLogos={pressLogosForDisplay}
            />}


            {isMobile && <VariantBHeroSectionMobile
                pressLogos={pressLogosForDisplay}
                titleRef={titleRef}
                reviewOverlayData={reviewOverlay}
                heroReviewsText={info?.heroReviewsText}
                title={title}
                cityName={city?.name}
                heroMedia={heroImage}
                heroDescription={info?.heroDescription}
                backgroundImageUrl={heroImage?.url}
                scrollToDivRef={sidebarScrollToDivRef}
                socialLinks={socialLinks}
                heroTitle={info?.heroTitle}
                rating={info?.rating}
                subtitle={pageData?.hero?.subtitle}
                isUpgrade={isUpgrade}
                breadcrumbds={
                    isUpgrade
                        ? [
                            { title: "Home", link: "/" },
                            { title: city?.name, link: city?.slug },
                            { title: page?.upgradeForTour?.title, link: page?.upgradeForTour?.slug },
                            { title },
                        ]
                        : [
                            { title: "Home", link: "/" },
                            { title: city?.name, link: city?.slug },
                            { title },
                        ]
                }
                dropdownData={pageData?.showDropdown ? pageData?.dropdowns : []}
                dropdownBackButtonText={page?.city?.name}
                dropdownBackButtonLink={page?.city?.slug}
                isEmbeddedPage={!!embedded?.embed}
                featureList={info?.featureList}

                duration={info?.duration}
                location={info?.location}
                numOfStops={info?.numOfStops ? `${info?.numOfStops} ${info?.stopsText ?? 'stops'}` : null}
                numOfPeople={info?.numOfPeople ? `${info?.numOfPeople} ${info?.peopleText ?? 'people max'}` : null}
                type={info?.type}
                funFact={info?.funFact}
                language={info?.language}
                wineTastings={info?.wineTastings}

                ctaButtonData={bookingButtonData}

                images={images}
            />}


            {
                embedded?.embed && <EmbeddedPageSection embed={embedded?.embed} />
            }

            {
                !embedded?.embed && <>

                    <div className="container_small">
                        <WillDoBookingWrapper>
                            <div ref={scrollToDivRef}>
                                <MobilePaddingWrapper>
                                    <VariantBWillDoSection
                                        title={whatYouWillDo?.title}
                                        description={whatYouWillDo?.description}
                                        note={whatYouWillDo?.note}
                                        items={whatYouWillDo?.items}
                                        isUpgrade={isUpgrade}
                                        upgradeTour={page?.upgradeTour}
                                        itineraryLabel={whatYouWillDo?.itineraryLabel}
                                    />
                                    <VariantBVideoSection
                                        videoUrl={media?.videoUrl}
                                        videoThumbnail={videoThumbnail}
                                        videoTitle={media?.videoTitle}
                                        videoSubtitle={media?.videoSubtitle}
                                    />
                                </MobilePaddingWrapper>
                            </div>

                            <div className={'mobile_only'}>
                                    <VariantBImagesSection
                                        images={images}
                                        imagesTitle={media?.imagesTitle}
                                        imagesSubtitle={media?.imagesSubtitle}
                                    />
                            </div>
                            <VariantBBookingSection
                                customBookingText={pageData?.booking?.customBookingText}
                                reviewOverlayData={reviewOverlay}
                                globalBookingLogo={bookingLogo}
                                disabledText={pageData?.booking?.disabledText}
                                embed={pageData?.booking?.embed}
                                price={info?.price}
                                crossedPrice={info?.crossedPrice}
                                currency={info?.currency}
                                bookingAwardsImage={bookingAwardsImage}
                                lowestPriceFlag={bookingLowestPriceFlag?.url}
                                lowestPriceText={pageData?.booking?.lowestPriceText}
                                reviewsText={pageData?.booking?.reviewsText}
                                title={pageData?.booking?.title}
                            />
                        </WillDoBookingWrapper>
                    </div>

                    <div className="container_small_slider desktop_only" style={{marginTop:'50px', marginBottom:'50px'}}>
                        <VariantBImagesSection
                            images={images}
                            imagesTitle={media?.imagesTitle}
                            imagesSubtitle={media?.imagesSubtitle}
                        />
                    </div>

                    <VariantBWillTasteSection
                        title={whatYouWillTaste?.title}
                        food={whatYouWillTaste?.food}
                        drinks={whatYouWillTaste?.drinks}
                        subtext={whatYouWillTaste?.subtext}
                        foodLabel={whatYouWillTaste?.foodLabel}
                        drinksLabel={whatYouWillTaste?.drinksLabel}
                    />


                    <div className="container_small_slider" style={{marginTop:'50px'}}>
                        <FactsSection
                            facts={facts}
                            cityName={city?.name}
                            factFirstIcon={page?.factFirstIcon}
                            factSecondIcon={page?.factSecondIcon}
                            factThirdIcon={page?.factThirdIcon}
                        />
                    </div>


                    <div className="container_small_slider">
                        <VariantBMeetingSpotsSection
                            guideInfo={meetings?.guideInfo}
                            title={meetings?.title}
                            description={meetings?.description}

                            email={meetings?.email}
                            spots={meetings?.spots}
                            isUpgrade={isUpgrade}
                            fullyBooked={meetings?.fullyBooked}
                            fullyBookedText={meetings?.fullBookedText}

                            cityName={city?.name}
                        />
                    </div>

                    <VariantBAboutSection
                        title={why?.title}
                        description={why?.description}
                        image={page?.whyImage}
                        footerData={footer}
                        ctaButtonData={bookingButtonData}
                    />

                    <VariantBSimilarToursSection
                        title={similar?.title}
                        tours={similarTours}
                        subtitle={similar?.subtitle}
                        sidebarTitle={similar?.sidebarTitle}
                        historicalTour={{
                            rating: city?.data?.historicalCard?.rating,
                            title: city?.data?.historicalCard?.title,
                            description: city?.data?.historicalCard?.description,
                            buttonText: city?.data?.historicalCard?.buttonText,
                            buttonLink: city?.data?.historicalCard?.buttonLink,
                            image: city?.historicalTourCardImage,
                        }}
                    />

                    <VariantBFaqSection
                        faqs={faqs}
                        title={pageData?.faqs?.title}
                    />
                    <VariantBBookEndSection
                        title={title}
                        cityName={city?.name}
                        reviewOverlayData={reviewOverlay}
                        ctaButtonData={bookingButtonData}
                    />
                </>
            }

        </>
    );
}


const WillDoBookingWrapper = styled.div`
    display: grid;
    grid-template-columns: 8fr 420px;
    gap: 40px;

    > * {
        min-width: 0;
    }

    @media only screen and (${breakpoints.mobile}) {
        grid-template-columns: 1fr;
        //padding: 10px;
        padding-top:10px;
        padding-bottom: 10px;
    }
`;



const MobilePaddingWrapper = styled.div`
    @media only screen and (${breakpoints.mobile}) {
        padding-left:20px;
        padding-right:20px;
    }
`;


